import { render } from "./BaseSpinner.vue?vue&type=template&id=deef99e8&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=deef99e8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deef99e8"]])

export default __exports__